import { render } from "./ContactsNewPeopleDialog.vue?vue&type=template&id=a76f0562"
import script from "./ContactsNewPeopleDialog.vue?vue&type=script&lang=js"
export * from "./ContactsNewPeopleDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__